import { cssVar } from '@toeverything/theme';
import type { Styles } from 'react-joyride';

export const piqueJoyrideStyles: Partial<Styles> = {
  options: {
    // Primary Pique brand color
    primaryColor: 'var(--affine-primary-color)', // #8652f4
    // Background colors using Pique's theme
    backgroundColor: 'var(--affine-background-primary-color)',
    arrowColor: 'var(--affine-background-primary-color)',
    // Text colors
    textColor: 'var(--affine-text-primary-color)',
    // Overlay with Pique's subtle styling
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    // Spotlight shadow with brand color
    spotlightShadow: '0 0 32px rgba(134, 82, 244, 0.3)',
    // Beacon styling
    beaconSize: 40,
    // High z-index to show above everything
    zIndex: 10000,
    // Responsive width - smaller for better fit
    width: 320,
  },
  beacon: {
    // Pique purple with pulse animation
    backgroundColor: 'var(--affine-primary-color)',
    border: '3px solid rgba(134, 82, 244, 0.3)',
    borderRadius: '50%',
    boxShadow: '0 0 0 6px rgba(134, 82, 244, 0.1)',
    cursor: 'pointer',
    height: 40,
    width: 40,
    zIndex: 10001,
    // Smooth hover transition
    transition: 'all 0.3s ease',
  },
  beaconInner: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: '2px solid var(--affine-primary-color)',
    borderRadius: '50%',
    height: 24,
    width: 24,
    // Pulse animation
    animation: 'pique-pulse 2s ease-in-out infinite',
  },
  tooltip: {
    // Pique's panel styling
    backgroundColor: 'var(--affine-background-primary-color)',
    borderRadius: '16px',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.12), 0 0 0 1px var(--affine-border-color)',
    color: 'var(--affine-text-primary-color)',
    fontSize: '14px',
    fontFamily: cssVar('fontFamily'),
    lineHeight: '1.5',
    padding: '20px',
    maxWidth: '320px',
    backdropFilter: 'blur(12px)',
    border: '1px solid var(--affine-border-color)',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    color: 'var(--affine-text-primary-color)',
    fontSize: '18px',
    fontWeight: 600,
    margin: '0 0 12px',
    fontFamily: cssVar('fontFamily'),
  },
  tooltipContent: {
    color: 'var(--affine-text-primary-color)',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: '0 0 20px',
    fontFamily: cssVar('fontFamily'),
  },
  tooltipFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px',
  },
  tooltipFooterSpacer: {
    display: 'flex',
    gap: '8px',
  },
  buttonNext: {
    backgroundColor: 'var(--affine-primary-color)',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: cssVar('fontFamily'),
    padding: '10px 20px',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(134, 82, 244, 0.2)',
  },
  buttonBack: {
    backgroundColor: 'transparent',
    border: '1px solid var(--affine-border-color)',
    borderRadius: '8px',
    color: 'var(--affine-text-secondary-color)',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: cssVar('fontFamily'),
    padding: '10px 16px',
    transition: 'all 0.2s ease',
  },
  buttonClose: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--affine-text-secondary-color)',
    cursor: 'pointer',
    fontSize: '20px',
    fontWeight: 400,
    height: '32px',
    padding: '0',
    position: 'absolute',
    right: '16px',
    top: '16px',
    width: '32px',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
  },
  buttonSkip: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--affine-text-secondary-color)',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: cssVar('fontFamily'),
    padding: '10px 16px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
  },
  spotlight: {
    borderRadius: '8px',
    transition: 'all 0.3s ease',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)',
    transition: 'all 0.3s ease',
  },
};